module.exports = __webpack_public_path__ + "asset/font-dollarbird-a0d0511bb89df796.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/style/icon/fonts/dollarbird.woff
// module id = EZq4
// module chunks = 3